import { useState } from "react";
import { Link } from "react-router-dom";

import { useCountdown } from "../Hooks/useCountdown";
import styles from "./news.modal.module.css";

const NewsModal = () => {
	const [modalVisible, setModalVisible] = useState(true);
	const {
		remainingDays,
		remainingHours,
		remainingMinutes,
		remainingSeconds
	} = useCountdown(new Date("2026-01-01T00:00:01").getTime());

	// checking if the user has visited the page and has seen the news modal //
	// useEffect(() => {
	// 	if (!localStorage.getItem("modalShown")) {
	// 	setModalVisible(true);
	// 	localStorage.setItem("modalShown", "true");
	// 	}
	// }, []);

	// const downloadImage = () => {
	// 	const link = document.createElement("a");
	// 	link.href = ESIRSJTBTIN;
	// 	link.download = "ESIRS JTB TIN";
	// 	document.body.appendChild(link);
	// 	link.click();
	// 	document.body.removeChild(link);
	// };

	return (
		<>
			{modalVisible && (
				<>
					<div
						className={`${styles.modalOverlay} ${
							modalVisible ? styles.visible : styles.invisible
						}`}
						onClick={() => setModalVisible(false)}
					></div>
					<div
						className={styles.modalContent}
						onClick={(e) => e.stopPropagation()}
						aria-label="announcement modal"
					>
						<div className={styles.top}>
							<button onClick={() => setModalVisible(false)}>
								&times;
							</button>
							<span>!</span>
							<span>Important Notice</span>
							<h1>Get Ready For E-Filing</h1>
							<p>
								Don’t wait until the last minute. Secure your
								ESBN access today.
							</p>
						</div>
						<div className={styles.body}>
							<h2>Before You Begin</h2>
							<ol>
								<li>
									Ensure that the email address and phone
									number linked to your ESBN are active and
									correct.
								</li>
								<li>
									Make sure you have your current ESBN
									password handy.
								</li>
							</ol>
							<div className={styles.forgot__password_section}>
								<h2>Forgot Your Password?</h2>
								<ul>
									<li>
										<i
											style={{
												marginRight: "12px",
												display: "inline-block",
												fontStyle: "normal"
											}}
										>
											🌐
										</i>
										<span>
											<span>Step 1</span>
											Visit{" "}
											<Link to="/login">
												https://irs.en.gov.ng/login
											</Link>
										</span>
									</li>
									<li>
										<i
											style={{
												marginRight: "12px",
												display: "inline-block",
												fontStyle: "normal"
											}}
										>
											🔒
										</i>
										<span>
											<span>Step 2</span>
											Click on "Forgot Password"
										</span>
									</li>
									<li>
										<i
											style={{
												marginRight: "12px",
												display: "inline-block",
												fontStyle: "normal"
											}}
										>
											📝
										</i>
										<span>
											<span>Step 3</span>
											Enter your ESBN and click "Submit"
										</span>
									</li>
								</ul>
							</div>
							<p className={styles.info}>
								You will receive a new system password via the
								email attached to your ESBN. You can use this to
								log in immediately or change it to a password of
								your choice.
							</p>
							<div className={styles.countdown}>
								<h2>
									Countdown to 2026 ANNUAL TAX RETURNS FILINg
								</h2>
								<div>
									<div>
										<span>Days</span>
										<span>{remainingDays}</span>
									</div>
									<div>
										<span>Hours</span>
										<span>{remainingHours}</span>
									</div>
									<div>
										<span>Minutes</span>
										<span>{remainingMinutes}</span>
									</div>
									<div>
										<span>Seconds</span>
										<span>{remainingSeconds}</span>
									</div>
								</div>
							</div>
							<p className={styles.footer}>
								<span>
									ESIRS - Enugu State Internal Revenue Service
								</span>{" "}
								<span>
									Need help? Contact support at{" "}
									<a href="tel:08075625555">08075625555</a> or{" "}
									<a href="mailto:esirs@enugustate.gov.ng">
										esirs@enugustate.gov.ng
									</a>
								</span>
							</p>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default NewsModal;
